module.exports = __webpack_public_path__ + "static/media/nl.37771745.svg";